import { t } from '@/i18n';
import type { PublicDownloadCsvDataType } from './csv-data-by-year';

const YEAR = 2025;
export const CSV_DATA_2025: PublicDownloadCsvDataType = {
  basicInformation: [
    {
      key: 'organizationInformation',
      localFileName: t(
        'ps-csv-file-name-rs-basic-information-organization-information',
        { year: YEAR },
      ),
    },
    {
      key: 'projectSummary',
      localFileName: t(
        'ps-csv-file-name-rs-basic-information-project-summary',
        { year: YEAR },
      ),
    },
    {
      key: 'policyMeasureLawsAndRegulations',
      localFileName: t(
        'ps-csv-file-name-rs-basic-information-policy-measure-laws-and-regulations',
        { year: YEAR },
      ),
    },
    {
      key: 'subsidyRate',
      localFileName: t('ps-csv-file-name-rs-basic-information-subsidy-rate', {
        year: YEAR,
      }),
    },
    {
      key: 'relatedProjects',
      localFileName: t(
        'ps-csv-file-name-rs-basic-information-related-projects',
        { year: YEAR },
      ),
    },
  ],
  budgetAndExecution: [
    {
      key: 'summary',
      localFileName: t('ps-csv-file-name-rs-budget-and-execution-summary', {
        year: YEAR,
      }),
    },
    {
      key: 'detail',
      localFileName: t('ps-csv-file-name-rs-budget-and-execution-detail', {
        year: YEAR,
      }),
    },
  ],
  wayToEffect: [
    {
      key: 'purposeResult',
      localFileName: t('ps-csv-file-name-rs-wey-to-effect-purpose-result', {
        year: YEAR,
      }),
    },
    {
      key: 'purposeConnection',
      localFileName: t('ps-csv-file-name-rs-wey-to-effect-purpose-connection', {
        year: YEAR,
      }),
    },
  ],
  inspectionEvaluation: [
    {
      key: 'evaluation',
      localFileName: t('ps-csv-file-name-rs-inspection-evaluation', {
        year: YEAR,
      }),
    },
  ],
  payee: [
    {
      key: 'paymentInformation',
      localFileName: t('ps-csv-file-name-rs-payee-payment-information', {
        year: YEAR,
      }),
    },
    {
      key: 'paymentBlockConnection',
      localFileName: t('ps-csv-file-name-rs-payee-payment-block-connection', {
        year: YEAR,
      }),
    },
    {
      key: 'paymentAmountBreakdown',
      localFileName: t('ps-csv-file-name-rs-payee-payment-amount-breakdown', {
        year: YEAR,
      }),
    },
    {
      key: 'contract',
      localFileName: t('ps-csv-file-name-rs-payee-contract', { year: YEAR }),
    },
  ],
  remark: [
    {
      key: 'remark',
      localFileName: t('ps-csv-file-name-rs-remark', { year: YEAR }),
    },
  ],
};
